export default __webpack_public_path__ + "static/media/Skeleton-3D-Model-Rigged-02.6448569d.jpg";